
import { getThemeColor } from "@/branding";
import { computed, defineComponent, inject, PropType } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<{ name: string; value: number | string }[]>,
      required: true,
    },
    tclass: String,
  },
  setup(props) {
    const values = inject(FormValidatedValuesKey);
    const errors = inject(FormValidatedErrorsKey);

    const onUpdate = inject(FormValidatedUpdateKey);

    const onChange = (event: Event) => {
      const { value } = event.target as HTMLInputElement;
      typeof onUpdate === "function" && onUpdate({ [props.name]: value });
    };

    return {
      onChange,
      theme: getThemeColor(),
      value: computed(() => values && values[props.name]),
      error: computed(() => errors && errors[props.name]),
    };
  },
});
